import React, { useState } from 'react';
import UserGuide from './UserGuide';

interface HelpButtonProps {
  section?: string;
  tooltip?: string;
  variant?: 'icon' | 'button' | 'link';
  className?: string;
}

const HelpButton: React.FC<HelpButtonProps> = ({ 
  section = 'overview', 
  tooltip = 'Help',
  variant = 'icon',
  className = ''
}) => {
  const [showGuide, setShowGuide] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowGuide(true);
  };

  const renderButton = () => {
    switch (variant) {
      case 'button':
        return (
          <button
            className={`btn btn-secondary help-btn ${className}`}
            onClick={handleClick}
            title={tooltip}
          >
            <i className="fas fa-question-circle"></i> Help
          </button>
        );
      case 'link':
        return (
          <a
            href="#"
            className={`help-link ${className}`}
            onClick={handleClick}
            title={tooltip}
            style={{ 
              color: '#3b82f6', 
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.25rem',
              fontSize: '0.875rem'
            }}
          >
            <i className="fas fa-question-circle"></i> Help
          </a>
        );
      case 'icon':
      default:
        return (
          <button
            className={`help-icon-btn ${className}`}
            onClick={handleClick}
            title={tooltip}
            style={{
              background: 'none',
              border: 'none',
              color: '#6b7280',
              cursor: 'pointer',
              padding: '0.5rem',
              borderRadius: '50%',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
              fontSize: '1.125rem'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#3b82f6';
              e.currentTarget.style.background = '#eff6ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#6b7280';
              e.currentTarget.style.background = 'transparent';
            }}
          >
            <i className="fas fa-question-circle"></i>
          </button>
        );
    }
  };

  return (
    <>
      {renderButton()}
      {showGuide && (
        <UserGuide
          onClose={() => setShowGuide(false)}
          currentSection={section}
        />
      )}
    </>
  );
};

export default HelpButton;

